import * as React from 'react';
import { styled } from '@glitz/react';
import { createMaxMobileViewportDecorator, createMinLargeViewportDecorator } from 'webapp/viewport';
import { addSelectContentEventToDataLayer } from 'webapp/tracking/events/content';
import { isSvenssons } from 'webapp/theme';
import Link from 'webapp/components/Link';

export function CollectionCard(props: NordicNest.Api.CollectionApiModel) {
  return (
    <Base
      to={props.url}
      onClick={() => addSelectContentEventToDataLayer({ id: props.id, type: 'collection_card', link: props.url })}
    >
      <BrandText>{props.brandName}</BrandText>
      <Title>{props.name}</Title>
    </Base>
  );
}

/** @glitz-dynamic */
const Base = styled(
  Link,
  createMinLargeViewportDecorator({
    padding: { x: t => t.sharedSpacing.xl, y: t => t.sharedSpacing.l },
  }),
  {
    display: 'block',
    backgroundColor: t => t.monochrome.color,
    padding: { x: t => t.sharedSpacing.l, y: t => t.sharedSpacing.m },
  },
);

const BrandText = styled.div(
  createMaxMobileViewportDecorator({
    marginBottom: t => t.sharedSpacing.xxs,
  }),
  {
    fontFamily: t => t.fontFamily?.primary,
    textTransform: 'uppercase',
    marginBottom: t => t.sharedSpacing.xs,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    color: t => t.dark.color,
    fontSize: t => t.fontSize.xxs,
  },
  isSvenssons &&
    createMinLargeViewportDecorator({
      fontSize: t => t.fontSize.xs,
    }),
);

const Title = styled.h2(
  createMaxMobileViewportDecorator({
    fontSize: t => t.fontSize.xs,
  }),
  {
    fontSize: t => t.fontSize.s,
    fontWeight: 400,
    marginBottom: 0,
  },
);
